module.exports = __webpack_public_path__ + "media/images/game/resources/satisfaction_medium-71e5b74d90205a4c63861ab2b37c2222.png";